import { Component, OnInit } from '@angular/core'
import {
  ACTIVITY_ID,
  ACTIVITY_NAME,
  CURRENT_STATUS,
  DAYS_ELAPSED,
  REQUEST_INITIATED_ON,
  RESPONSE_DUE_BY
} from 'src/app/constants/ui.columns'
import { ActivityAPIModel, StatusCountAPIModel } from 'src/app/models/api.model'
import { ActivityService } from 'src/app/services/activity/activity.service'
import { ViewForSelectionComponent } from '../../common/view-for-selection/view-for-selection.component'
import { GlobalConstants } from 'src/app/constants/global-constants'
import {
  ACTIVITY_RECEIVED,
  COMPLETED,
  IN_PROGRESS,
  PENDING_WITH_DEPARTMENT,
  PENDING_WITH_EE,
  PENDING_WITH_ER
} from 'src/app/constants/stats-cards'

@Component({
  selector: 'app-activity-dashboard',
  templateUrl: './activity-dashboard.component.html',
  styleUrls: ['./activity-dashboard.component.scss']
})
export class ActivityDashboardComponent implements OnInit {
  readonly routingLink = `/${GlobalConstants.ROUTING.ACTIVITY}/{0}/${GlobalConstants.ROUTING.DETAILS}`
  itemsList: ActivityAPIModel[] = []
  statusCountMap: StatusCountAPIModel[] = []
  itemsTableColumns = [ACTIVITY_ID, ACTIVITY_NAME, REQUEST_INITIATED_ON, CURRENT_STATUS, DAYS_ELAPSED, RESPONSE_DUE_BY]
  statsCards = [ACTIVITY_RECEIVED, IN_PROGRESS, PENDING_WITH_ER, PENDING_WITH_DEPARTMENT, PENDING_WITH_EE, COMPLETED]

  constructor(private activityService: ActivityService) {}

  ngOnInit(): void {
    this.activityService.dispatchFetchActivityDashboardDataAction(
      ViewForSelectionComponent.defaultValue,
      GlobalConstants.SORT_COLUMN.CREATED_DATETIME,
      null
    )

    this.activityService.getActivityDashboardInfo().subscribe((activityDashboardInfo) => {
      if (activityDashboardInfo) {
        this.itemsList = activityDashboardInfo?.activityItemsList?.content
        this.statusCountMap = activityDashboardInfo?.statusCountMap
      }
    })
  }

  handleViewForData($event: any) {
    this.activityService.dispatchFetchActivityDashboardDataAction($event, 'createdDatetime', null)
  }
}
